import { send_request } from '../../../utils/Request';

export const MAX_API_KEYS = 10;
export const KEY_DISPLAY_LENGTH = 40;
export const REDACTED_KEY_PREFIX_LENGTH = 36;
export const COPY_FEEDBACK_DURATION = 1500;
export const SNACKBAR_DURATION = 2000;
export const ADMIN_SCOPE = 'Admin';
export const EDITOR_SCOPE = 'Editor';
export const USER_SCOPE = 'User';
export const styles = {
  skeleton: {
    container: { p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    textLarge: { mb: 0.5 },
    textSmall: { mt: 0.5 },
  },
  alert: {
    base: { mb: 3, borderRadius: '6px' },
    keyContainer: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.04)',
      p: 1,
      borderRadius: '4px',
      mt: 1,
      position: 'relative',
    },
    keyTextContainer: {
      display: 'flex',
      alignItems: 'center',
      flexGrow: 1,
      overflow: 'hidden',
    },
    keyText: {
      fontFamily: 'monospace',
      flexGrow: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    buttonContainer: { display: 'flex', alignItems: 'center' },
    visibilityButton: { color: 'text.secondary' },
  },
  form: {
    container: { mb: 4 },
    title: { mb: 1 },
    inputContainer: { display: 'flex', gap: 1 },
    textField: {
      '& .MuiOutlinedInput-root': {
        borderRadius: '6px',
      },
    },
    button: {
      borderRadius: '6px',
      whiteSpace: 'nowrap',
      px: 2,
      height: '38px',
      minWidth: '140px',
    },
    warningText: { mt: 1, display: 'block' },
    loadingIcon: { ml: 1 },
  },
  keyItem: {
    container: isPendingDeletion => ({
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: isPendingDeletion ? 'rgba(255,0,0,0.02)' : 'transparent',
      '&:hover': {
        backgroundColor: isPendingDeletion ? 'rgba(255,0,0,0.02)' : 'rgba(0,0,0,0.01)',
      },
      transition: 'background-color 0.2s ease',
    }),
    infoContainer: { mb: 0.5 },
    nameText: { fontWeight: 500 },
    metaContainer: { mt: 0.5 },
    keyText: { fontFamily: 'monospace' },
    actionsContainer: { display: 'flex', gap: 1 },
    deleteWarning: {
      px: 2,
      pb: 2,
      backgroundColor: 'rgba(255,0,0,0.02)',
    },
  },
  list: {
    container: {
      border: '1px solid rgba(0,0,0,0.12)',
      borderRadius: '8px',
      overflow: 'hidden',
    },
    emptyState: {
      p: 3,
      textAlign: 'center',
      backgroundColor: 'rgba(0,0,0,0.02)',
      borderRadius: '6px',
    },
  },
  dialog: {
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    closeButton: { fontSize: '18px' },
    description: { mb: 3 },
    sectionTitle: { mb: 2 },
  },
};

export const fetchCurrentUser = async () => {
  return await send_request('authz-service/user-info', '', '', 'GET');
};

export const fetchApiKeys = async () => {
  return await send_request('authz-service/apikeys', '', '', 'GET');
};

export const createApiKey = async requestData => {
  return await send_request('authz-service/apikey', requestData, '', 'POST');
};

export const deleteApiKey = async id => {
  return await send_request(`authz-service/apikey/${id}`, '', '', 'DELETE');
};

export const updateAllowedWorkflowsByApiKeyId = async (id, workflows) => {
  const allowedWorkflowIds = workflows?.map(workflow => workflow?.projectId) || [];

  return await send_request(
    `authz-service/apikey/${id}/allowedWorkflows`,
    allowedWorkflowIds,
    '',
    'PUT'
  );
};

export const retrieveAllowedWorkflowsByApiKeyId = async apiKeyId => {
  return await send_request(`authz-service/apikey/${apiKeyId}/allowedWorkflows`, '', '', 'GET');
};
